export const START_GET_PATIENT_LIST = "START_GET_PATIENT_LIST";
export const SUCCESS_GET_PATIENT_LIST = "SUCCESS_GET_PATIENT_LIST";
export const ERROR_GET_PATIENT_LIST = "ERROR_GET_PATIENT_LIST";

export const START_DELETE_PATIENT = "START_DELETE_PATIENT";
export const SUCCESS_DELETE_PATIENT = "SUCCESS_DELETE_PATIENT";
export const ERROR_DELETE_PATIENT = "ERROR_DELETE_PATIENT";

export const START_CREATE_PATIENT = "START_CREATE_PATIENT";
export const SUCCESS_CREATE_PATIENT = "SUCCESS_CREATE_PATIENT";
export const ERROR_CREATE_PATIENT = "ERROR_CREATE_PATIENT";

export const START_UPDATE_PATIENT = "START_UPDATE_PATIENT";
export const SUCCESS_UPDATE_PATIENT = "SUCCESS_UPDATE_PATIENT";
export const ERROR_UPDATE_PATIENT = "ERROR_UPDATE_PATIENT";

export const START_GET_SINGLE_PATIENT = "START_GET_SINGLE_PATIENT";
export const SUCCESS_GET_SINGLE_PATIENT = "SUCCESS_GET_SINGLE_PATIENT";
export const ERROR_GET_SINGLE_PATIENT = "ERROR_GET_SINGLE_PATIENT";

export const START_GET_SURGERY_FIELD_LIST = "START_GET_SURGERY_FIELD_LIST";
export const SUCCESS_GET_SURGERY_FIELD_LIST = "SUCCESS_GET_SURGERY_FIELD_LIST";
export const ERROR_GET_SURGERY_FIELD_LIST = "ERROR_GET_SURGERY_FIELD_LIST";

export const START_PHARMACY_LIST = "START_PHARMACY_LIST";
export const SUCCESS_PHARMACY_LIST = "SUCCESS_PHARMACY_LIST";
export const ERROR_PHARMACY_LIST = "ERROR_PHARMACY_LIST";

export const START_DRUG_LIST = "START_DRUG_LIST";
export const SUCCESS_DRUG_LIST = "SUCCESS_DRUG_LIST";
export const ERROR_GURG_LIST = "ERROR_GURG_LIST";

export const START_GROUP_FIELD_LIST = "START_GROUP_FIELD_LIST";
export const SUCCESS_GROUP_FIELD_LIST = "SUCCESS_GROUP_FIELD_LIST";
export const ERROR_GROUP_FIELD_LIST = "ERROR_GROUP_FIELD_LIST";

export const START_PATIENT_URGENCY_STATUS_CHANGE =
  "START_PATIENT_URGENCY_STATUS_CHANGE";
export const SUCCESS_PATIENT_URGENCY_STATUS_CHANGE =
  "SUCCESS_PATIENT_URGENCY_STATUS_CHANGE";
export const ERROR_PATIENT_URGENCY_STATUS_CHANGE =
  "ERROR_PATIENT_URGENCY_STATUS_CHANGE";

export const RESET_PATIENT_STATE = "RESET_PATIENT_STATE";

export const START_GET_PATIENT_NOTE_LIST = "START_GET_PATIENT_NOTE_LIST";
export const SUCCESS_GET_PATIENT_NOTE_LIST = "SUCCESS_GET_PATIENT_NOTE_LIST";
export const ERROR_GET_PATIENT_NOTE_LIST = "ERROR_GET_PATIENT_NOTE_LIST";

export const START_CREATE_PATIENT_NOTE = "START_CREATE_PATIENT_NOTE";
export const SUCCESS_CREATE_PATIENT_NOTE = "SUCCESS_CREATE_PATIENT_NOTE";
export const ERROR_CREATE_PATIENT_NOTE = "ERROR_CREATE_PATIENT_NOTE";

export const START_UPDATE_PATIENT_NOTE = "START_UPDATE_PATIENT_NOTE";
export const SUCCESS_UPDATE_PATIENT_NOTE = "SUCCESS_UPDATE_PATIENT_NOTE";
export const ERROR_UPDATE_PATIENT_NOTE = "ERROR_UPDATE_PATIENT_NOTE";

export const START_DELETE_PATIENT_NOTE = "START_DELETE_PATIENT_NOTE";
export const SUCCESS_DELETE_PATIENT_NOTE = "SUCCESS_DELETE_PATIENT_NOTE";
export const ERROR_DELETE_PATIENT_NOTE = "ERROR_DELETE_PATIENT_NOTE";

export const START_GET_SINGLE_PATIENT_NOTE = "START_GET_SINGLE_PATIENT_NOTE";
export const SUCCESS_GET_SINGLE_PATIENT_NOTE =
  "SUCCESS_GET_SINGLE_PATIENT_NOTE";
export const ERROR_GET_SINGLE_PATIENT_NOTE = "ERROR_GET_SINGLE_PATIENT_NOTE";

export const START_GET_PATIENT_MEDICATION_HISTORY_LIST =
  "START_GET_PATIENT_MEDICATION_HISTORY_LIST";
export const SUCCESS_GET_PATIENT_MEDICATION_HISTORY_LIST =
  "SUCCESS_GET_PATIENT_MEDICATION_HISTORY_LIST";
export const ERROR_GET_PATIENT_MEDICATION_HISTORY_LIST =
  "ERROR_GET_PATIENT_MEDICATION_HISTORY_LIST";

export const START_CREATE_PATIENT_SURGERY = "START_CREATE_PATIENT_SURGERY";
export const SUCCESS_CREATE_PATIENT_SURGERY = "SUCCESS_CREATE_PATIENT_SURGERY";
export const ERROR_CREATE_PATIENT_SURGERY = "ERROR_CREATE_PATIENT_SURGERY";

export const START_IMPORT_CSV = "START_IMPORT_CSV";
export const SUCCESS_IMPORT_CSV = "SUCCESS_IMPORT_CSV";
export const ERROR_IMPORT_CSV = "ERROR_IMPORT_CSV";

export const START_GET_IMPORT_CSV_LIST = "START_GET_IMPORT_CSV_LIST";
export const SUCCESS_GET_IMPORT_CSV_LIST = "SUCCESS_GET_IMPORT_CSV_LIST";
export const ERROR_GET_IMPORT_CSV_LIST = "ERROR_GET_IMPORT_CSV_LIST";

export const START_DELETE_MULTIPLE_AND_SINGLE_CSV =
  "START_DELETE_MULTIPLE_AND_SINGLE_CSV";
export const SUCCESS_DELETE_MULTIPLE_AND_SINGLE_CSV =
  "SUCCESS_DELETE_MULTIPLE_AND_SINGLE_CSV";
export const ERROR_DELETE_MULTIPLE_AND_SINGLE_CSV =
  "ERROR_DELETE_MULTIPLE_AND_SINGLE_CSV";

export const START_STATUS_PATIENT_UPDATE = "START_STATUS_PATIENT_UPDATE";
export const SUCCESS_STATUS_PATIENT_UPDATE = "SUCCESS_STATUS_PATIENT_UPDATE";
export const ERROR_STATUS_PATIENT_UPDATE = "ERROR_STATUS_PATIENT_UPDATE";

export const START_UPDATE_FIELD_PATIENT = "START_UPDATE_FIELD_PATIENT";
export const SUCCESS_UPDATE_FIELD_PATIENT = "SUCCESS_UPDATE_FIELD_PATIENT";
export const ERROR_UPDATE_FIELD_PATIENT = "ERROR_UPDATE_FIELD_PATIENT";

export const START_ARCHIVE_MEDICATION = "START_ARCHIVE_MEDICATION";
export const SUCCESS_ARCHIVE_MEDICATION = "SUCCESS_ARCHIVE_MEDICATION";
export const ERROR_ARCHIVE_MEDICATION = "ERROR_ARCHIVE_MEDICATION";

export const START_PROFILE_UPDATE = "START_PROFILE_UPDATE";
export const SUCCESS_PROFILE_UPDATE = "SUCCESS_PROFILE_UPDATE";
export const ERROR_PROFILE_UPDATE = "ERROR_PROFILE_UPDATE";

export const START_PATIENT_MULTI_DELETE = "START_PATIENT_MULTI_DELETE";
export const SUCCESS_PATIENT_MULTI_DELETE = "SUCCESS_PATIENT_MULTI_DELETE";
export const ERROR_PATIENT_MULTI_DELETE = "ERROR_PATIENT_MULTI_DELETE";

export const START_GET_IMPORT_PATIENT_DUPLICATE =
  "START_GET_IMPORT_PATIENT_DUPLICATE";
export const SUCCESS_GET_IMPORT_PATIENT_DUPLICATE =
  "SUCCESS_GET_IMPORT_PATIENT_DUPLICATE";
export const ERROR_GET_IMPORT_PATIENT_DUPLICATE =
  "ERROR_GET_IMPORT_PATIENT_DUPLICATE";

export const START_IMPORT_PATIENT_DUPLICATE_DELETE =
  "START_IMPORT_PATIENT_DUPLICATE_DELETE";
export const SUCCESS_IMPORT_PATIENT_DUPLICATE_DELETE =
  "SUCCESS_IMPORT_PATIENT_DUPLICATE_DELETE";
export const ERROR_IMPORT_PATIENT_DUPLICATE_DELETE =
  "ERROR_IMPORT_PATIENT_DUPLICATE_DELETE";

export const START_PATIENT_ALL_DELETE = "START_PATIENT_ALL_DELETE";
export const SUCCESS_PATIENT_ALL_DELETE = "SUCCESS_PATIENT_ALL_DELETE";
export const ERROR_PATIENT_ALL_DELETE = "ERROR_PATIENT_ALL_DELETE";
